// import React, { useState } from "react";
// import { getIn } from "formik";
// import FormControl from "@mui/material/FormControl";
// import InputLabel from "@mui/material/InputLabel";
// import Typography from "@mui/material/Typography";
// import TextField from "@mui/material/TextField";
// import { IconButton, InputAdornment } from "@mui/material";
// import VisibilityIcon from "@mui/icons-material/Visibility";
// import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

// export const TextFormField = ({ field, form, label, backgroundColor, isRequired, ...props }) => {
// 	const errorText = getIn(form.touched, field.name) && getIn(form.errors, field.name);
// 	const [showPassword, setShowPassword] = useState(false);
// 	const handleClickShowPassword = () => setShowPassword((prev) => !prev);
// 	const handleMouseDownPassword = (event) => event.preventDefault();

// 	return (
// 		<FormControl fullWidth error={!!errorText}>
// 			{label && (
// 				<InputLabel sx={{ ml: -1.6 }} shrink htmlFor={field.name}>
// 					<Typography variant="h6" sx={{ textTransform: "capitalize" }}>
// 						{label}
// 						{isRequired && (
// 							<Typography variant="h5" color="error" component="span">
// 								{" *"}
// 							</Typography>
// 						)}
// 					</Typography>
// 				</InputLabel>
// 			)}
// 			<TextField
// 				{...field}
// 				fullWidth
// 				id={field.name}
// 				type={props.type === "password" ? (showPassword ? "text" : "password") : props.type} // <-- fix here
// 				sx={{
// 					backgroundColor: "#F7FAFF",
// 					border: "1px solid #4169E1",
// 					borderRadius: "5px",
// 					mt: 2,
// 					"& fieldset": { border: "none" },
// 					"& .MuiInputBase-input": { padding: "12px 10px" },
// 					"& .css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input": { fontSize: "12px" },
// 					...(props.type === "number" && {
// 						"& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button": {
// 							display: "none",
// 							margin: 0,
// 						},
// 						"& input[type=number]": {
// 							"-moz-appearance": "textfield",
// 						},
// 					}),
// 				}}
// 				{...props}
// 				onBlur={(e) => {
// 					form.handleBlur(e);
// 				}}
// 				InputProps={{
// 					endAdornment:
// 						props.type === "password" ? (
// 							<InputAdornment position="end">
// 								<IconButton
// 									aria-label="toggle password visibility"
// 									onClick={handleClickShowPassword}
// 									onMouseDown={handleMouseDownPassword}
// 									edge="end"
// 								>
// 									{showPassword ? (
// 										<VisibilityOffIcon fontSize="small" sx={{ color: "red" }} />
// 									) : (
// 										<VisibilityIcon fontSize="small" sx={{ color: "red" }} />
// 									)}
// 								</IconButton>
// 							</InputAdornment>
// 						) : null,
// 				}}
// 			/>

// 			{errorText && <Typography variant="h6" fontSize={"10px"} color="red">{errorText}</Typography>}
// 		</FormControl>
// 	);
// };


import React, { useState } from "react";
import { getIn } from "formik";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import { IconButton, InputAdornment } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

// export const TextFormField = ({ field, form, label, backgroundColor, isRequired, onChange, ...props }) => {
// 	const errorText = getIn(form.touched, field.name) && getIn(form.errors, field.name);
// 	const [showPassword, setShowPassword] = useState(false);
// 	const handleClickShowPassword = () => setShowPassword((prev) => !prev);
// 	const handleMouseDownPassword = (event) => event.preventDefault();

// 	// Extract type from props so we can safely override it
// 	const { type, ...restProps } = props;

// 	// const handleChange = (e) => {
// 	// 	let value = e.target.value;
// 	// 	if (props.uppercase) value = value.toUpperCase();
// 	// 	form.setFieldValue(field.name, value);

// 	// 	if (onChange) {
// 	// 		onChange(value, e); // call custom onChange if provided
// 	// 	}
// 	// };

// 	const handleChange = (e) => {
// 	let value = e.target.value;

// 	// ✅ Convert to number if type="number"
// 	if (type === "number") {
// 		value = value === "" ? "" : Number(value);
// 	}

// 	// ✅ Convert to uppercase if required
// 	if (props.uppercase && typeof value === "string") {
// 		value = value.toUpperCase();
// 	}

// 	form.setFieldValue(field.name, value);

// 	if (onChange) {
// 		onChange(value, e); // custom onChange if provided
// 	}
// };


// 	return (
// 		<FormControl fullWidth error={!!errorText}>
// 			{label && (
// 				<InputLabel sx={{ ml: -1.6 }} shrink htmlFor={field.name}>
// 					<Typography variant="h6" sx={{ textTransform: "capitalize" }}>
// 						{label}
// 						{isRequired && (
// 							<Typography variant="h5" color="error" component="span">
// 								{" *"}
// 							</Typography>
// 						)}
// 					</Typography>
// 				</InputLabel>
// 			)}
// 			<TextField
// 				{...field}
// 				{...restProps}
// 				fullWidth
// 				id={field.name}
// 				type={type === "password" ? (showPassword ? "text" : "password") : type}
// 				autoComplete={props.autoComplete ?? "off"}
// 				sx={{
// 					backgroundColor: "#F7FAFF",
// 					border: "1px solid #4169E1",
// 					borderRadius: "5px",
// 					mt: 2,
// 					"& fieldset": { border: "none" },
// 					"& .MuiInputBase-input": { padding: "12px 10px", textTransform: props.uppercase ? "uppercase" : "none" },
// 					"& .css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input": { fontSize: "12px" },
// 					...(type === "number" && {
// 						"& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button": {
// 							display: "none",
// 							margin: 0,
// 						},
// 						"& input[type=number]": {
// 							"-moz-appearance": "textfield",
// 						},
// 					}),
// 					"& .MuiInputBase-input.Mui-disabled": {
// 						color: "#4d4d4d",
// 						WebkitTextFillColor: "#4d4d4d",
// 					}
// 				}}
// 				// onChange={(e) => {
// 				// 	const value = props.uppercase ? e.target.value.toUpperCase() : e.target.value;
// 				// 	form.setFieldValue(field.name, value);
// 				// }}
// 				onChange={handleChange}
// 				onBlur={(e) => {
// 					form.handleBlur(e);
// 				}}
// 				InputProps={{
// 					endAdornment:
// 						type === "password" ? (
// 							<InputAdornment position="end">
// 								<IconButton
// 									aria-label="toggle password visibility"
// 									onClick={handleClickShowPassword}
// 									onMouseDown={handleMouseDownPassword}
// 									edge="end"
// 								>
// 									{showPassword ? (
// 										<VisibilityOffIcon fontSize="small" />
// 									) : (
// 										<VisibilityIcon fontSize="small" />
// 									)}
// 								</IconButton>
// 							</InputAdornment>
// 						) : null,
// 				}}
// 			/>
// 			{errorText && (
// 				<Typography variant="h6" fontSize={"10px"} color="red">
// 					{errorText}
// 				</Typography>
// 			)}
// 		</FormControl>
// 	);
// };



export const TextFormField = ({ field, form, label, backgroundColor, isRequired, onChange, ...props }) => {
    const errorText = getIn(form.touched, field.name) && getIn(form.errors, field.name);
    const [showPassword, setShowPassword] = useState(false);
    const handleClickShowPassword = () => setShowPassword((prev) => !prev);
    const handleMouseDownPassword = (event) => event.preventDefault();

    const { type, ...restProps } = props;

    const handleChange = (e) => {
        // ✅ Optimization: If no special transformation is needed, 
        // use Formik's default handler which is much faster.
        if (!props.uppercase && type !== "number" && !onChange) {
            field.onChange(e); 
            return;
        }

        // Logic for specialized fields (Numbers/Uppercase/Custom onChange)
        let value = e.target.value;

        if (type === "number") {
            value = value === "" ? "" : Number(value);
        }

        if (props.uppercase && typeof value === "string") {
            value = value.toUpperCase();
        }

        form.setFieldValue(field.name, value);

        if (onChange) {
            onChange(value, e); 
        }
    };

    return (
        <FormControl fullWidth error={!!errorText}>
            {label && (
                <InputLabel sx={{ ml: -1.6 }} shrink htmlFor={field.name}>
                    <Typography variant="h6" sx={{ textTransform: "capitalize" }}>
                        {label}
                        {isRequired && (
                            <Typography variant="h5" color="error" component="span">
                                {" *"}
                            </Typography>
                        )}
                    </Typography>
                </InputLabel>
            )}
            <TextField
                {...field}
                {...restProps}
                fullWidth
                id={field.name}
                type={type === "password" ? (showPassword ? "text" : "password") : type}
                autoComplete={props.autoComplete ?? "off"}
                sx={{
                    backgroundColor: "#F7FAFF",
                    border: "1px solid #4169E1",
                    borderRadius: "5px",
                    mt: 2,
                    "& fieldset": { border: "none" },
                    "& .MuiInputBase-input": { padding: "12px 10px", textTransform: props.uppercase ? "uppercase" : "none" },
                    "& .css-16wblaj-MuiInputBase-input-MuiOutlinedInput-input": { fontSize: "12px" },
                    ...(type === "number" && {
                        "& input[type=number]::-webkit-outer-spin-button, & input[type=number]::-webkit-inner-spin-button": {
                            display: "none",
                            margin: 0,
                        },
                        "& input[type=number]": {
                            "-moz-appearance": "textfield",
                        },
                    }),
                    "& .MuiInputBase-input.Mui-disabled": {
                        color: "#4d4d4d",
                        WebkitTextFillColor: "#4d4d4d",
                    }
                }}
                onChange={handleChange}
                onBlur={field.onBlur} // Use field.onBlur for better performance
                InputProps={{
                    endAdornment:
                        type === "password" ? (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                >
                                    {showPassword ? (
                                        <VisibilityOffIcon fontSize="small" />
                                    ) : (
                                        <VisibilityIcon fontSize="small" />
                                    )}
                                </IconButton>
                            </InputAdornment>
                        ) : null,
                }}
            />
            {errorText && (
                <Typography variant="h6" fontSize={"10px"} color="red">
                    {errorText}
                </Typography>
            )}
        </FormControl>
    );
};